/**
 * The CRF Builder's message for the standard clinical forms the form
 * suggestion left out because the protocol gives no source for them
 * (backlog 21 (e), (ppp), (u); server side in
 * functions/src/crf/suggestCoverage.ts gateSuggestedClinicalForms).
 *
 * Pure, so it is tested through functions/vitest.web.config.ts.
 */
const SHOWN = 5;

export function notSuggestedFormsText(list: unknown): string | null {
  if (!Array.isArray(list)) return null;
  const names = list
    .map((x) => (x && typeof x === "object" ? String((x as { name?: unknown }).name ?? "").trim() : ""))
    .filter((n) => n.length > 0);
  if (names.length === 0) return null;
  const one = names.length === 1;
  const shown = names.slice(0, SHOWN).join(", ");
  const more = names.length > SHOWN ? ` and ${names.length - SHOWN} more` : "";
  return `Not suggested because the protocol does not call for ${one ? "it" : "them"}: ${shown}${more}. Use Add Form if the study needs ${one ? "it" : "them"}.`;
}
